import React, { useEffect, useState } from 'react';
import { Grid, Typography } from '@mui/material';

import ImageDashboard1 from "assets/images/Parallax/SessionG/BN_Dashboard_1.png"; //รายจ่ายเงินกองทน
import ImageDashboard2 from "assets/images/Parallax/SessionG/BN_Dashboard_2.png"; //เอกสารเผยแพร่
import ImageDashboard3 from "assets/images/Parallax/SessionG/BN_Dashboard_3.png"; //การสนับสนุนเงิน อุดหนุนโครงการ
import ImageDashboard4 from "assets/images/Parallax/SessionG/BN_Dashboard_4.png"; //การขอสนับสนุนเงิน อุดหนุนโครงการ
import ImageDashboard5 from "assets/images/Parallax/SessionG/BN_Dashboard_5.png"; //เกี่ยวกับเรา
import ImageDashboard6 from "assets/images/Parallax/SessionG/BN_Dashboard_6.png"; //แกลอรี่
import ImageDashboard7 from "assets/images/Parallax/SessionG/BN_Dashboard_6.png"; //แกลอรี่

import { ParseHtml, RouterDOM } from 'utilities/utilities';
import BreadcrumbsBar from 'components/Breadcrumbs';

const ImageShow = () => {

    const Router = RouterDOM();

    const [sImageDashboard, setsImageDashboard] = useState("");
    const [sTextHead, setsTextHead] = useState("");
    const [sTextContent, setsTextContent] = useState("");

    useEffect(() => {
        let sRoute = Router.GetCurrentRoute();
        let sPathName = sRoute.replace("/", "");
        handleChangeDataMode(sPathName);
    }, [Router])

    const handleChangeDataMode = (sModeName) => {        
        switch (sModeName) {
            case "dashboard": //FundExpenses = รายจ่ายเงินกองทน (Dashboard)
                setsImageDashboard(ImageDashboard1);
                setsTextHead("รายจ่ายเงินกองทุน <br /> จัดการซากดึกดำบรรพ์");
                setsTextContent("เพื่อการบริหารจัดการซากดึกดำบรรพ์ <br /> อย่างยังยืน");
                break;
            case "publisheddocuments": //PublishedDocuments = เอกสารเผยแพร่
                setsImageDashboard(ImageDashboard2);
                setsTextHead("เอกสารเผยแพร่");
                setsTextContent("เพื่อการบริหารจัดการซากดึกดำบรรพ์ <br /> อย่างยังยืน");
                break;
            case "moneysupport": //MoneySupport = การสนับสนุนเงิน อุดหนุนโครงการ
                setsImageDashboard(ImageDashboard3);
                setsTextHead("การสนับสนุนเงิน <br /> อุดหนุนโครงการ");
                setsTextContent("เพื่อการบริหารจัดการซากดึกดำบรรพ์ <br /> อย่างยังยืน");
                break;
            case "requestingfinancialsupport": //RequestingFinancialSupport = การขอสนับสนุนเงิน อุดหนุนโครงการ
                setsImageDashboard(ImageDashboard4);
                setsTextHead("การขอสนับสนุนเงิน <br /> อุดหนุนโครงการ");
                setsTextContent("เพื่อการบริหารจัดการซากดึกดำบรรพ์ <br /> อย่างยังยืน");
                break;
            case "aboutus": //AboutUs = เกี่ยวกับเรา
                setsImageDashboard(ImageDashboard5);
                setsTextHead("เกี่ยวกับเรา");
                setsTextContent("เพื่อการบริหารจัดการซากดึกดำบรรพ์ <br /> อย่างยั่งยืน");
                break;
            case "gallerylistimg": //Gallery = แกลอรี่ 
                setsImageDashboard(ImageDashboard6);
                setsTextHead("Album");
                setsTextContent("Gallery");
                break;
            case "gallerydetail": //Gallery = แกลอรี่ 
                setsImageDashboard(ImageDashboard7);
                setsTextHead("Album");
                setsTextContent("Gallery");
                break;
            case "searchsite":
                setsImageDashboard(ImageDashboard6);
                // setsTextHead("ค้นหา");
                break;

            case "applymember": //Apply Member = สมัครสมาชิก 
                setsImageDashboard("");
                setsTextHead("สมัครสมาชิก");
                setsTextContent("");
                break;
            default:
                setsImageDashboard("");
                setsTextHead("");
                setsTextContent("");
                break;
        }
    };

    return (
        <React.Fragment>
            <div className='container-image-show'>
                <Grid container alignItems='center' item xs={12}>
                    <Grid item xs={12} className="session-g-container" sx={{ backgroundImage: `url(${sImageDashboard})`, }}>
                        <div className='image-title'>
                            <Typography>{ParseHtml(sTextHead)}</Typography>
                            <Typography variant="caption" color={'#ffffff'} fontSize={'1.1em'} lineHeight={1} fontWeight={300}>{ParseHtml(sTextContent)}</Typography>
                        </div>
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                        <BreadcrumbsBar isFrontEnd={true} />
                    </Grid>
                </Grid>
            </div>
        </React.Fragment>
    )
}

export default ImageShow
